module.exports = __webpack_public_path__ + "static/img/model-bg6.6a5f0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg6.jpg
// module id = JvX8
// module chunks = 0